module.exports = __webpack_public_path__ + "img/customer-background.735defb5.png";